import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) throw new Error('Root element not found');

// React Snap kullanılırken hydrate, otherwise render
// React Snap kullanılırken hydrate, otherwise render
const hasChildNodes = rootElement.hasChildNodes();

// Kontrol et: Eğer root içinde "static-shell" class'ına sahip bir div varsa, bu BİZİM eklediğimiz static shell'dir.
// Bu durumda hydrate YAPMAMALIYIZ, createRoot ile üzerine yazmalıyız.
const isStaticShell = rootElement.querySelector('.static-shell') !== null;
const shouldHydrate = hasChildNodes && !isStaticShell;

if (shouldHydrate) {
  hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Pro Tip: DOM-first rendering.
  // İlk önce tarayıcının statik HTML'i (index.html'deki shell) boyamasına izin ver.
  // React'ı main thread boşaldığında (idle) başlat.
  const initReact = () => {
    createRoot(rootElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  };

  // requestIdleCallback varsa kullan, yoksa setTimeout ile ertele
  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(initReact);
  } else {
    setTimeout(initReact, 0);
  }
}
